import { DOMInfo, DropAction } from '@candulabs/craft';

const padding = 3;

export const calculateIndicatorPosition = (
  pos: DropAction,
  canvasDOMInfo: DOMInfo, // which canvas is cursor at
  bestTargetDomInfo: DOMInfo | null, // closest element in canvas (null if canvas is empty)
  thickness = 3,
) => {
  let top = 0;
  let left = 0;
  let width = 0;
  let height = 0;
  const { where } = pos;

  const elDim = bestTargetDomInfo;

  if (elDim) {
    // If it's not in flow (like flex-row child or inline-block)
    if (!elDim.inFlow) {
      width = thickness;
      height = elDim.outerHeight - padding * 2;
      top = elDim.top + padding;
      left = (where === 'before' ? elDim.left : elDim.left + elDim.outerWidth) + padding;
    } else {
      width = elDim.outerWidth - padding * 2;
      height = thickness;
      top = where === 'before' ? elDim.top + padding : elDim.bottom - padding * 2;
      left = elDim.left + padding;
    }
  } else if (canvasDOMInfo) {
    top = canvasDOMInfo.top + canvasDOMInfo.padding.top;
    left = canvasDOMInfo.left + canvasDOMInfo.padding.left;
    width =
      canvasDOMInfo.outerWidth -
      canvasDOMInfo.padding.right -
      canvasDOMInfo.padding.left -
      canvasDOMInfo.margin.left -
      canvasDOMInfo.margin.right;
    height = thickness;
  }
  return {
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
    height: `${height}px`,
    direction: width > height ? 'horizontal' : 'vertical',
  };
};
